import api from 'plugin/api';

/**
 *  @description 검사결과 > 위생검사결과목록 API
 */

async function snttnExamRstList(params) {
  const url = '/sfsh/inspection/result/snttnExamRst';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 검사결과 > 위생검사결과상세 API
 */
async function snttnExamRstDetail(seq) {
  const url = `/sfsh/inspection/result/snttnExamRst/${seq}`;

  const response = await api.get(url);
  return response;
}

export { snttnExamRstList, snttnExamRstDetail };
